export enum ReurbModality {
  REURB_E = 'REURB_E',
  REURB_S = 'REURB_S',
  REURB_I = 'REURB_I',
}
